module.exports = __webpack_public_path__ + "img/yc-bg2-btn.4662448e.png";